export const CONVERSATION_TITLE_MAX_LENGTH = 80

export const titleFromFirstQuestion = (question: string): string => {
  const chars = Array.from(question.trim())
  return chars.slice(0, CONVERSATION_TITLE_MAX_LENGTH).join('')
}
